import { HiExternalLink, HiPhone, HiLocationMarker } from 'react-icons/hi';
import HeroSection from '../components/ui/HeroSection';
import ChalkboardBackground from '../components/ui/ChalkboardBackground';
import { SectionHeader } from '../components/ui/Section';
import Button from '../components/ui/Button';
import siteContent from '../data/siteContent.json';
import homeBg from '../assets/images/bb-background.png';
import Seo from '../components/Seo';

const leReveServices = [
  { name: 'Morpheus8', description: 'Non-surgical radiofrequency and micro-needling for skin tightening, acne scars, stretch marks, fine lines, and wrinkles.' },
  { name: 'Skin Pen', description: 'Professional microneedling treatment to stimulate collagen and rejuvenate skin.' },
  { name: 'Filler', description: 'Dermal filler injections for volume restoration and facial contouring.' },
  { name: 'Dysport', description: 'Neuromodulator injections to smooth fine lines and wrinkles.' },
  { name: 'Lumecca IPL', description: 'Intense pulsed light therapy for skin tone, pigmentation, and vascular concerns.' },
  { name: 'Diolaze', description: 'Advanced laser hair removal for smooth, lasting results.' },
  { name: 'Signature Glow Facial', description: 'Custom facial treatment tailored to your skin needs.' },
  { name: 'Dermaplane', description: 'Gentle exfoliation for ultra-smooth, radiant skin.' },
  { name: 'Chemical Peels', description: 'Chemical exfoliation to improve skin texture, tone, and clarity.' },
];

export default function MedSpa() {
  return (
    <>
      <Seo
        title="Le Reve Med Spa Partnership"
        description="Blush & Bobby partners with Le Reve Med Spa in Kansas City for pre-wedding skin treatments, facials, and beauty prep before your big day."
        path="/med-spa"
      />
      {/* Hero */}
      <HeroSection title="Med Spa" backgroundImage={homeBg} />

      {/* Collaboration Section */}
      <ChalkboardBackground className="py-20">
        <div className="container-custom">
          <SectionHeader
            title="Blush & Bobby x Le Rêve Med Spa"
            subtitle="Elevating your beauty experience through expert collaboration"
            dark={true}
          />

          <div className="max-w-3xl mx-auto text-center mb-12">
            <p className="text-chalk/80 leading-relaxed text-lg">
              We're proud to collaborate with Le Rêve Med Spa to bring you advanced aesthetic treatments.
              Whether you're preparing for your big day or simply investing in your skin,
              Le Rêve offers expert-level med spa services to complement your beauty routine.
            </p>
          </div>

          {/* Services List */}
          <div className="max-w-2xl mx-auto">
            <h3 className="text-xl md:text-2xl font-headline font-semibold text-chalk uppercase tracking-wider text-center mb-8">
              Services Offered
            </h3>
            <ul className="space-y-4 text-lg">
              {leReveServices.map((service) => (
                <li
                  key={service.name}
                  className="py-3 border-b border-dusty-rose/20"
                >
                  <span className="font-display font-semibold text-chalk">{service.name}</span>
                  <p className="text-sm text-dusty-rose/70 mt-1">{service.description}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </ChalkboardBackground>

      {/* Contact & Location */}
      <ChalkboardBackground
        as="section"
        backgroundImage={homeBg}
        backgroundOpacity={0.5}
        className="py-12 md:py-16 lg:py-20 border-y border-dusty-rose/10"
      >
        <div className="container-custom">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-headline font-semibold mb-8 text-chalk uppercase tracking-wider">
              Book Your Appointment
            </h2>

            <div className="space-y-4 mb-10">
              <div className="flex items-center justify-center gap-2 text-chalk/80">
                <HiLocationMarker className="h-5 w-5 text-dusty-rose" />
                <span>Le Rêve Med Spa @ Willow Salon & Suites</span>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-chalk/80">
                <div className="flex items-center gap-2">
                  <HiPhone className="h-5 w-5 text-dusty-rose" />
                  <span>Le Rêve: <a href="tel:9137321769" className="text-dusty-rose hover:underline">(913) 732-1769</a></span>
                </div>
                <div className="flex items-center gap-2">
                  <HiPhone className="h-5 w-5 text-dusty-rose" />
                  <span>Blush & Bobby: <a href="tel:8166545289" className="text-dusty-rose hover:underline">{siteContent.phone}</a></span>
                </div>
              </div>
            </div>

            <Button
              href="https://lereveks.com/"
              target="_blank"
              rel="noopener noreferrer"
              variant="outline"
              size="lg"
              className="!text-xs"
            >
              Visit Le Rêve Med Spa
              <HiExternalLink className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </div>
      </ChalkboardBackground>
    </>
  );
}
